__turbopack_context__.v({
  "title": "createTitleWithBadge-module-scss-module__fWH26G__title",
  "titleWithBadge": "createTitleWithBadge-module-scss-module__fWH26G__titleWithBadge",
});
